import { render, staticRenderFns } from "./CategoryList.vue?vue&type=template&id=7b3fb864&scoped=true&"
import script from "./CategoryList.vue?vue&type=script&setup=true&lang=js&"
export * from "./CategoryList.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3fb864",
  null
  
)

export default component.exports